import * as React from "react";

function MilkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.054 5.985a.944.944 0 00-.836-.485h-2.402a.96.96 0 00-.865.526c-.566 1.134-1.83 3.877-1.943 5.97a.004.004 0 01-.004.004.004.004 0 00-.004.004V18.5a2 2 0 002 2h4a2 2 0 002-2v-6.497a.003.003 0 00-.003-.003.003.003 0 01-.003-.003c-.1-2.39-1.368-4.965-1.94-6.012z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 9,
    y: 3.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M10 12.5V18"
  }));
}

export default MilkIcon;